import React, { useContext, useState } from "react";
import SelectedTick from "../../../../assets/images/selected-tick.svg";
import styled from "styled-components";
import LayoutContext from "../../../../contexts/LayoutContext";
const StyledProductType = styled.div`
    &.dropdown-mini,
    &.dropdown-mini * {
        box-sizing: border-box;
    }
    &.dropdown-mini {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        position: absolute;
        box-shadow: var(--dropdown-ds-box-shadow, 0px 0px 10px 0px rgba(17, 22, 32, 1));
        z-index: 9;
        margin-top: 5px;
    }
    .frame-1000011163 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-75 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .frame-79 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 211px;
        height: 38px;
        cursor: pointer;
    }
    .checkbox {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-313638 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .all {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-84 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 211px;
        height: 38px;
        cursor: pointer;
    }
    .checkbox2 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .ellipse-1 {
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-secondary, #8c8f93);
        border-width: 1px;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .frame-313639 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .jackets-coats {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-85 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 211px;
        height: 38px;
        cursor: pointer;
    }
    .frame-313640 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .knitwear {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-86 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 211px;
        height: 38px;
        cursor: pointer;
    }
    .cashmere {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-87 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 211px;
        height: 38px;
        cursor: pointer;
    }
    .dresses-jumpsuits {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-88 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 211px;
        height: 38px;
        cursor: pointer;
    }
    .shirts-blouses {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-89 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 211px;
        height: 38px;
        cursor: pointer;
    }
    .shorts {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-76 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .rainwear {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .trousers {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .tops-t-shirts {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .jeans {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .shorts-skirts {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .loungewear {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-90 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .shirts {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-77 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .sweatshirts-hoodies {
        color: var (--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .blazers {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .suiting {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .lingerie {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .casual {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .party {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .rectangle-5 {
        background: #3e3e3e;
        border-radius: 999px;
        flex-shrink: 0;
        width: 4px;
        height: 51px;
        position: absolute;
        right: 4px;
        top: 50%;
        translate: 0 -50%;
    }
    .frame-3136392 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .btn-xs-primary {
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
        cursor: pointer;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
export default function ProductType({ toggleProductTypeSelection, selectedType }) {
    const { setShowProductType, selectedTypes, setSelectedTypes } = useContext(LayoutContext);

    const handleSelect = type => {
        if (type === "All") {
            setSelectedTypes(["All"]);
        } else {
            setSelectedTypes(prevSelected =>
                prevSelected.includes(type)
                    ? prevSelected.filter(item => item !== type)
                    : [...prevSelected.filter(item => item !== "All"), type]
            );
        }
        toggleProductTypeSelection(type);
    };

    const isSelected = type => selectedTypes.includes(type);

    return (
        <StyledProductType className="dropdown-mini">
            <div className="frame-1000011163">
                <div className="frame-75">
                    <div className="frame-79" onClick={() => handleSelect("All")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("All") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313638">
                            <div className="all">All</div>
                        </div>
                    </div>
                    <div className="frame-84" onClick={() => handleSelect("Jackets & Coats")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Jackets & Coats") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313639">
                            <div className="jackets-coats">Jackets &amp; Coats</div>
                        </div>
                    </div>
                    <div className="frame-85" onClick={() => handleSelect("Knitwear")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Knitwear") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="knitwear">Knitwear</div>
                        </div>
                    </div>
                    <div className="frame-86" onClick={() => handleSelect("Cashmere")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Cashmere") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="cashmere">Cashmere</div>
                        </div>
                    </div>
                    <div className="frame-87" onClick={() => handleSelect("Dresses & Jumpsuits")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Dresses & Jumpsuits") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="dresses-jumpsuits">Dresses &amp; Jumpsuits</div>
                        </div>
                    </div>
                    <div className="frame-88" onClick={() => handleSelect("Shirts & Blouses")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Shirts & Blouses") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="shirts-blouses">Shirts &amp; Blouses</div>
                        </div>
                    </div>
                    <div className="frame-89" onClick={() => handleSelect("Shorts")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Shorts") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="shorts">Shorts</div>
                        </div>
                    </div>
                </div>
                <div className="frame-76">
                    <div className="frame-79" onClick={() => handleSelect("Rainwear")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Rainwear") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313638">
                            <div className="rainwear">Rainwear</div>
                        </div>
                    </div>
                    <div className="frame-89" onClick={() => handleSelect("Trousers")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Trousers") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="trousers">Trousers</div>
                        </div>
                    </div>
                    <div className="frame-85" onClick={() => handleSelect("Tops & T-shirts")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Tops & T-shirts") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="tops-t-shirts">Tops &amp; T-shirts</div>
                        </div>
                    </div>
                    <div className="frame-86" onClick={() => handleSelect("Jeans")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Jeans") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="jeans">Jeans</div>
                        </div>
                    </div>
                    <div className="frame-87" onClick={() => handleSelect("Shorts & Skirts")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Shorts & Skirts") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="shorts-skirts">Shorts &amp; Skirts</div>
                        </div>
                    </div>
                    <div className="frame-88" onClick={() => handleSelect("Loungewear")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Loungewear") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="loungewear">Loungewear</div>
                        </div>
                    </div>
                    <div className="frame-90" onClick={() => handleSelect("Shirts")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Shirts") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="shirts">Shirts</div>
                        </div>
                    </div>
                </div>
                <div className="frame-77">
                    <div className="frame-79" onClick={() => handleSelect("Sweatshirts & Hoodies")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Sweatshirts & Hoodies") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313638">
                            <div className="sweatshirts-hoodies">Sweatshirts &amp; Hoodies</div>
                        </div>
                    </div>
                    <div className="frame-90" onClick={() => handleSelect("Blazers")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Blazers") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313638">
                            <div className="blazers">Blazers</div>
                        </div>
                    </div>
                    <div className="frame-89" onClick={() => handleSelect("Suiting")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Suiting") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="suiting">Suiting</div>
                        </div>
                    </div>
                    <div className="frame-85" onClick={() => handleSelect("Lingerie")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Lingerie") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="lingerie">Lingerie</div>
                        </div>
                    </div>
                    <div className="frame-86" onClick={() => handleSelect("Jeans")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Jeans") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="jeans">Jeans</div>
                        </div>
                    </div>
                    <div className="frame-87" onClick={() => handleSelect("Casual")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Casual") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="casual">Casual</div>
                        </div>
                    </div>
                    <div className="frame-88" onClick={() => handleSelect("Party")}>
                        <div className="checkbox2">
                            <div className="ellipse-1">
                                {isSelected("Party") && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                            </div>
                        </div>
                        <div className="frame-313640">
                            <div className="party">Party</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="frame-3136392">
                <div
                    className="btn-xs-primary"
                    onClick={e => {
                        e.preventDefault();
                        setShowProductType(false);
                    }}>
                    <div className="button">Done</div>
                </div>
            </div>
        </StyledProductType>
    );
}
